import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { login } from "../../DAL/auth/login";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useIds } from "../../hook/AdminContext";
import { LogoDevOutlined } from "@mui/icons-material";
import logo from "../../assets/images/logotalent.png";
import LoginSlide from "./loginSlide";
import { web_url, project_mode } from "../../config/config";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
  Box,
} from "@mui/material";
import Registration from "./Registration";
import { admin_default_setting_without_auth } from "../../DAL/partner/partners";

export default function Login() {
  console.log(project_mode, "asdlhakhsdiushmode");
  const [showLoader, setShowLoader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [registerPopupOpen, setRegisterPopupOpen] = useState(false);
  const [userType, setUserType] = useState("candidate");
  const [adminSetting, setAdminSetting] = useState();

  const { setUserInfo, userInfo, setIds } = useIds();
  const navigate = useNavigate();
  const [loginStates, setLoginStates] = useState({
    email: "",
    password: "",
    loading: false,
  });

  const handleChange = (e) => {
    setLoginStates({ ...loginStates, [e.target.name]: e.target.value });
  };

  const navigateForgot = (e) => {
    e.preventDefault();
    if (!localStorage.getItem("token")) {
      navigate("/forgot-password");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginStates((old) => ({ ...old, loading: true }));
    const login_data = {
      email: loginStates.email,
      password: loginStates.password,
      type: 1,
    };
    const response = await login(login_data);
    console.log(response, "responseresponseresponse");
    if (response.code === 200) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("user", JSON.stringify(response.user));
      setUserInfo(response.user);

      setLoginStates((old) => ({ ...old, loading: false }));
      setShowLoader(true);

      setTimeout(() => {
        navigate("/home");
        enqueueSnackbar(response.message, { variant: "success" });
      }, 3000);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoginStates((old) => ({ ...old, loading: false }));
    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    setRegisterPopupOpen(true);
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const fetchAdminSettings = async () => {
    const data = await admin_default_setting_without_auth();
    if (data.code === 200) {
      await setAdminSetting(data?.admin_portal_settings);
    } else {
      enqueueSnackbar(data?.message, { variant: "error" });
    }
  };
  useEffect(() => {
    fetchAdminSettings();
  }, []);
  const handleRegisterClose = () => {
    setRegisterPopupOpen(false);
  };
  console.log(adminSetting, "adminsettingsasashd");
  const handleRegisterConfirm = () => {
    setRegisterPopupOpen(false);

    if (userType === "candidate") {
      const candidateUrl = adminSetting?.candidate_redirect_url;
      if (candidateUrl && candidateUrl.trim() !== "") {
        window.open(candidateUrl, "_blank");
      } else {
        window.open(
          "https://clientdev.talentsourceplatform.com/login",
          "_blank"
        );
      }
    } else {
      const clientUrl = adminSetting?.client_redirect_url;
      if (clientUrl && clientUrl.trim() !== "") {
        window.open(`${clientUrl}`, "_blank");
      } else {
        console.warn("client_redirect_url is not defined or empty.");
      }
    }
  };

  useEffect(() => {
    if (showLoader) {
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            navigate("/home");
            return 100;
          }
          return prev + 2; // increase 2% every 100ms (approx 5 seconds)
        });
      }, 100);
      return () => clearInterval(interval);
    }
  }, [showLoader]);

  if (showLoader) {
    return <LoginSlide progress={progress} />;
  }

  return (
    <div className="container login_page">
      <div className="row justify-content-center">
        <div className="col-12 col-md-4 login-box mt-5">
          <h2 className="login-title">Login</h2>
          <p className="login-subtitle">
            Login allows user access by verifying credentials like username and
            password.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="" className="mb-1">
                Email*
              </label>
              <input
                required
                style={{ borderRadius: "5px" }}
                type="email"
                name="email"
                value={loginStates.email}
                onChange={handleChange}
                placeholder="Enter your email*"
                className="input-field"
              />
            </div>
            <div className=" position-relative password-field">
              <label htmlFor="" className="mb-1">
                Password*
              </label>
              <input
                required
                style={{ borderRadius: "5px" }}
                type={passwordVisible ? "text" : "password"}
                name="password"
                value={loginStates.password}
                onChange={handleChange}
                placeholder="Enter Password*"
                className="input-field"
              />
              <span
                className="eye-icon position-absolute"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ right: "18px", top: "35px", cursor: "pointer" }}
              >
                {passwordVisible ? (
                  <VisibilityOutlinedIcon className="eye-icon" />
                ) : (
                  <VisibilityOffOutlinedIcon className="eye-icon" />
                )}
              </span>
            </div>
            <div className="forgot-password">
              <span
                onClick={navigateForgot}
                className="text-end mt-0 mb-0"
                style={{
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "17.07px",
                  marginTop: "20px",
                  cursor: "pointer",
                  display: "inline-block",
                }}
              >
                Forgot Password?
              </span>
            </div>
            <button
              type="submit"
              className="large-button-contained mt-3"
              disabled={loginStates.loading}
            >
              {loginStates.loading ? "Logging in..." : "Login"}
            </button>
          </form>
          <p className="text-center mt-2 color-white" style={{ marginTop: 0 }}>
            Don't have an account?{" "}
            <a
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                letterSpacing: "1px",
                color: "#fff",
              }}
              onClick={handleRegisterClick}
            >
              Register
            </a>
          </p>
        </div>
      </div>

      {/* Registration Type Popup */}
      <Registration
        handleRegisterConfirm={handleRegisterConfirm}
        registerPopupOpen={registerPopupOpen}
        handleRegisterClose={handleRegisterClose}
        handleUserTypeChange={handleUserTypeChange}
        userType={userType}
      />
    </div>
  );
}
